import awsdk from 'awsdk';

// IVR_REQUESTED
// IVR_TIMEOUT
// IVR_DIALING_CONSUMER
// IVR_CONSUMER_UNREACHABLE
// IVR_CONSUMER_FAILED
// IVR_DIALING_PROVIDER

export const ConsumerInitiatedIVRStatus = awsdk.AWSDKConsumerInitiatedIVRStatus;
export type ConsumerInitiatedIVRStatus = typeof ConsumerInitiatedIVRStatus;
